import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import styles from "./styles";
import UnifiedListing from "./UnifiedListing";

const useStyles = makeStyles((theme) => styles(theme));

export const AcfPubListingBlock = (props) => {
  const classes = useStyles();

  // if (props.name === "AcfPubListingBlock") {
  //   return null;
  // }

  const data = useStaticQuery(graphql`
    query UnifiedListQuery {
      allWpPub(sort: { fields: title, order: ASC }) {
        nodes {
          PubData {
            brand
            featuredImage
            localFile {
              id
              publicURL
              childImageSharp {
                gatsbyImageData(
                  width: 920
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  transformOptions: { fit: COVER, cropFocus: CENTER }
                )
              }
            }
            name
            displayLocation
            telephone
            hasOwnWebsite
            url
            tenancyStatus
            crmId
            facilityAccommodation
            latitude
            longitude
            address2
            stayWithUsFeatured
            suppress
            googlePlaceId
          }
          id
          slug
        }
      }
    }
  `);

  const selectedBrands = props?.block?.blockPubListing?.pubType ?? [];
  const selectedPubs =
    props?.block?.blockPubListing?.pubsToDisplay?.map((pub) => pub.id) ?? [];
  const pubs = data.allWpPub.nodes.filter((pub, index) => {
    if (
      selectedBrands.indexOf("stay_with_us_featured") > -1 &&
      pub?.PubData?.stayWithUsFeatured
    ) {
      return true;
    }
    if (
      selectedBrands.indexOf("select_pubs") > -1 &&
      selectedPubs.indexOf(pub?.id) > -1
    ) {
      return true;
    }
    if (selectedBrands.indexOf(pub?.PubData?.brand) > -1) {
      return true;
    }
    return false;
  });
  return (
    <div
      className={`pub-listing ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.pubListing} ${classes.pubListingTheme}`}
    >
      <UnifiedListing pubs={pubs} />
    </div>
  );
};

export const AcfPubListingBlockFragment = graphql`
  fragment AcfPubListingBlock on WpBlock {
    ... on WpAcfPubListingBlock {
      attributes {
        className
      }
      blockPubListing {
        pubType
        pubsToDisplay {
          ... on WpPub {
            id
            slug
            PubData {
              featuredImage
              localFile {
                id
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    width: 920
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                    transformOptions: { fit: COVER, cropFocus: CENTER }
                  )
                }
              }
              name
              displayLocation
              telephone
              hasOwnWebsite
              url
              facilityAccommodation
              latitude
              longitude
              address2
              crmId
              googlePlaceId
            }
          }
        }
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const AcfPubListingBlockPreview = `
  ... on AcfPubListingBlock {
    name
    attributes {
      className
    }
    blockPubListing {
      pubType
      pubsToDisplay {
        ... on Pub {
          id
          slug
          PubData {
            featuredImage
            name
            displayLocation
            telephone
            hasOwnWebsite
            url
            facilityAccommodation
            latitude
            longitude
            address2
            crmId
            googlePlaceId
          }
        }
      }
    }
  }
`;
